import { Vue, Component } from 'vue-property-decorator';

@Component
export default class MobileHelperMixin extends Vue {
  readonly defautMaxHeight: number = 304;
  readonly defautMaxHeightMobile: number = 116;

  get selectHeight() {
    return this.getSelectHeight();
  }

  getSelectHeight(defautMaxHeight: number = this.defautMaxHeight, defautMaxHeightMobile: number = this.defautMaxHeightMobile) {
    return this.$vuetify.breakpoint.xsOnly 
      ? defautMaxHeightMobile
      : defautMaxHeight; 
  }
}